var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29336 13.7061C5.68398 14.0967 6.31836 14.0967 6.70898 13.7061L11.709 8.70605C12.0996 8.31543 12.0996 7.68106 11.709 7.29043C11.3184 6.89981 10.684 6.8998 10.2934 7.29043L6.99961 10.5873L6.99961 0.999804C6.99961 0.446679 6.55274 -0.00019598 5.99961 -0.000196028C5.44649 -0.000196076 4.99961 0.446679 4.99961 0.999804L4.99961 10.5873L1.70586 7.29355C1.31523 6.90293 0.680859 6.90293 0.290234 7.29355C-0.100391 7.68418 -0.100391 8.31855 0.290234 8.70918L5.29023 13.7092L5.29336 13.7061Z",
    fill: "#4EFF3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDownIcon);
export default __webpack_public_path__ + "static/media/green-down-icon.43ff04e8940c1057f042dc616651a58e.svg";
export { ForwardRef as ReactComponent };